/**
 * Brand Configuration — Single source of truth for theming.
 * SmileyGift — מתנות שמביאות חיוך
 */

export interface BrandConfig {
  name: string;
  tagline: string;
  description: string;
  domain: string;
  locale: string;
  direction: "rtl" | "ltr";
  fontFamily: string;
  fontUrl: string;
  colors: {
    primary: string;
    primaryForeground: string;
    accent: string;
    accentForeground: string;
    background: string;
    foreground: string;
    card: string;
    badge: string;
    badgeForeground: string;
    success: string;
    successForeground: string;
    hot: string;
    hotForeground: string;
    muted: string;
    mutedForeground: string;
    border: string;
    ring: string;
  };
  gradientPrimary: string;
  gradientAccent: string;
  ogImage: string;
  favicon: string;
}

export const brand: BrandConfig = {
  name: "SmileyGift",
  tagline: "מתנות שמביאות חיוך",
  description: "חנות המתנות המובילה בישראל — מתנות מיוחדות שמביאות חיוך",
  domain: "www.smileyland.co.il",
  locale: "he_IL",
  direction: "rtl",
  fontFamily: "'Assistant', sans-serif",
  fontUrl: "/fonts/assistant-hebrew.woff2",
  colors: {
    primary: "45 95% 50%",
    primaryForeground: "0 0% 5%",
    accent: "38 90% 55%",
    accentForeground: "0 0% 5%",
    background: "220 30% 6%",
    foreground: "45 10% 92%",
    card: "220 25% 10%",
    badge: "45 95% 50%",
    badgeForeground: "0 0% 5%",
    success: "45 95% 50%",
    successForeground: "0 0% 5%",
    hot: "0 80% 55%",
    hotForeground: "0 0% 100%",
    muted: "220 18% 15%",
    mutedForeground: "220 12% 55%",
    border: "220 18% 18%",
    ring: "45 95% 50%",
  },
  gradientPrimary: "linear-gradient(135deg, hsl(45 95% 50%), hsl(38 90% 42%))",
  gradientAccent: "linear-gradient(135deg, hsl(38 90% 55%), hsl(30 85% 45%))",
  ogImage: "/og-image.png",
  favicon: "/favicon.ico",
};
